import { useEffect, useState } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch ,useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import { getcase } from '../../redux/actions/cases';
import { truncateTitle } from '../../middleware/truncateTitle';
import { renderText } from '../hooks/TextVeiw';
import { Loader, PDFViewer } from '../utils';
import { media } from '../../server';
import { getPleading } from '../../redux/actions/pleading';
const Sliceinfo=({sliceName , sliceData})=>{
  return(
    <div className="flex max-w-[25rem] flex-row  gap-2   p-2">
    <p className="text-tcolor-6 font-kufi text-md">{sliceName}:</p>
    <p className="text-tcolor-4 font-kufi text-md font-semibold dark:text-tcolor-1">{sliceData}</p>
  </div>
  )
}
function ViewPleading() {
  const { t } = useTranslation()
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPleading(id));
  }, [dispatch, id]);

  const { pleadingData, isLoading } = useSelector((state) => state.Pleadings);

  return (<>{
    isLoading ? <Loader /> :
      <div className="container bg-back-primery rounded-md  p-3 ">
           <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t('case Details')}</h2>
        <div className="flex flex-col">
       
          <div className="flex max-w-[15rem] flex-row gap-4 items-center p-2 border border-gray-300 rounded-lg">
            <p className="text-tcolor-6 font-kufi text-md">{ t('Pleading Number')}:</p>
            <p className="text-tcolor-4 font-kufi text-md font-semibold dark:text-tcolor-1">{pleadingData?.pleadingNumber}</p>
          </div>
        
          <div className="grid lg:grid-cols-2 grid-cols-1 mt-10 pt-5 gap-2  border border-b-0 border-l-0 border-r-0  border-t-n-10">
          <Sliceinfo sliceName={t('case Number' )} sliceData={pleadingData?.caseId.caseNumber} />
          <Sliceinfo sliceName={t('Pleading Name')} sliceData={pleadingData?.pleadingName} />
          <Sliceinfo sliceName={t("client Name")} sliceData={truncateTitle(pleadingData?.clientName,3)} />
          <Sliceinfo sliceName={t("opponant Name")} sliceData={truncateTitle(pleadingData?.opponentName,3)} />
          <Sliceinfo sliceName={t("Daate")} sliceData={pleadingData?.date} />
    
          <div className="flex w-full flex-col  gap-2   p-2">
    <p className="text-tcolor-6 font-kufi text-md">{t("Notes")}:</p>
    <p className="text-tcolor-4 font-kufi text-md p-2 border rounded-md  font-semibold dark:text-tcolor-1">{renderText(pleadingData?.notes)}</p>

   <div className="h-[180px] my-2 relative" >
    <PDFViewer
     
     fileName={pleadingData?.file instanceof File ? pleadingData.file.name : pleadingData?.file}
     fileUrl={pleadingData?.file instanceof File ? URL.createObjectURL(pleadingData?.file) : `${media}${encodeURIComponent(pleadingData?.file)}`}
   
   />
</div></div>
          </div>
        </div>
      </div>
  }</>
    
  )
}

export default ViewPleading